import { useTheme } from '@mui/material/styles';

export type KpiStatus = 'green' | 'red' | 'amber';

export const useKpiTrend = () => {
    const theme = useTheme();
    const colors = theme.palette;

    const getKpiStatus = ({
        current,
        previous,
        target,
        reverseTrend,
        threshold = 5, // sample threshold percentage for "steady" status
    }: {
        current: number;
        previous: number;
        target?: number;
        reverseTrend: boolean;
        threshold?: number;
    }): KpiStatus => {
        const improved = reverseTrend ? current < previous : current > previous;
        const worsened = reverseTrend ? current > previous : current < previous;

        if (improved) return 'green';
        if (worsened) return 'red';

        const withinThreshold =
            Math.abs(current - previous) <= (threshold / 100) * previous;

        if (withinThreshold && target !== undefined) {
            const meetsTarget = reverseTrend
                ? current <= target
                : current >= target;

            return meetsTarget ? 'green' : 'amber';
        }

        return 'amber';
    };

    const getBgColorByStatus = (status: KpiStatus) => {
        switch (status) {
            case 'green':
                return colors.kpiTile.background.changeDown;
            case 'red':
                return colors.kpiTile.background.changeUp;
            case 'amber':
                return colors.kpiTile.background.steady;
            default:
                return colors.widget.background.card;
        }
    };

    return {
        getKpiStatus,
        getBgColorByStatus,
    };
};
